export default function buddylist(state = '', action){
    if (action.type === 'buddylist') {
      return state = action.buddylist;
    } else {
      return state;
    }
  }